import React from 'react';

const AgeGate = ({ onConfirm }) => (
  <div className="ff-root">
    <div className="ff-age-gate" data-testid="ff-age-gate" role="dialog" aria-modal="true" aria-labelledby="ff-age-title">
      <div className="ff-age-card">
        <p className="ff-eyebrow" style={{ color: 'var(--ff-gold)', letterSpacing: 3, textTransform: 'uppercase', fontSize: 12, margin: '0 0 8px' }}>
          The Lokal Winery
        </p>
        <h2 id="ff-age-title" className="ff-serif">Are you 19 years of age or older?</h2>
        <p>You must be 19+ to view our Corporate & Custom Wine program and submit a custom wine request.</p>
        <div className="ff-age-actions">
          <button
            className="ff-btn ff-btn-primary ff-btn-lg"
            data-testid="ff-age-yes"
            onClick={onConfirm}
          >
            Yes, enter
          </button>
          <a
            href="https://google.com"
            data-testid="ff-age-no"
            className="ff-btn ff-btn-ghost ff-btn-lg"
          >
            No, exit
          </a>
        </div>
        <p style={{ fontSize: 12, marginTop: 24, color: 'var(--ff-brown-soft)' }}>
          Valid government-issued identification may be required. Please enjoy responsibly.
        </p>
      </div>
    </div>
  </div>
);

export default AgeGate;
